// Cheap noise-stripping for a synced email's timeline teaser — shared by
// every feed that renders an email snippet (site dashboard, owner rollup,
// ...) so they all read the same, not a hand-copied heuristic per page.
// Cuts the (already whitespace-collapsed, single-line) snippet at the first
// obvious signature/quote marker. Not an email parser: a signature that hits
// no marker still shows in full, but callers pair this with line-clamp-2 to
// cap it visually either way. The full untouched text is still one click
// away via the email detail modal.
const NOISE_MARKERS: RegExp[] = [
  /\bon\s.{1,120}?\swrote:/i,
  /\bregards,?\b/i,
  /\btoll[- ]?free\b/i,
  /\bmailto:/i,
  /\bunsubscribe\b/i,
  /\bconfidential(ity)?\b/i,
  /\bgps coordinates?\b/i,
  /\bsent from my (iphone|android|mobile)/i,
  /\s>{1,3}\s/
];

export function cleanEmailPreview(text: string): string {
  let cut = text.length;
  for (const re of NOISE_MARKERS) {
    const m = re.exec(text);
    if (m && m.index < cut) cut = m.index;
  }
  const cleaned = text.slice(0, cut).trim();
  return cleaned || text;
}
